module.exports = __webpack_public_path__ + "assets/img/2021-12.a85841d9.png";